import Personalizer from 'personalizer';
import { MEASUREMENT_UNITS } from 'Workouts/constants/BenchmarkExercisesConstants';
import i18next from 'i18next';
i18next.loadNamespaces(['units']);

export const WORKOUT_TABS = {
    myWorkouts: {
        key: 'workouts',
        titleKey: 'my_workouts',
        url: '/workouts'
    },
    benchmarkExercises: {
        key: 'benchmark-exercises',
        titleKey: 'benchmark_exercises_title',
        url: '/benchmark-exercises',
        isConditioned: true // this field can be removed when enhanced strength training role is removed
    },
    findWorkout: {
        key: 'find-workout',
        titleKey: 'find_a_workout',
        url: '/find-workout'
    }
};

export const getLinkedBenchmarkExercise = (exerciseKey, categoryKey, benchmarkExercises) => {
    return benchmarkExercises.find((benchmark) => {
        return (
            benchmark.linkedBenchmarkExercises &&
            benchmark.linkedBenchmarkExercises.find(
                (linkedBE) => linkedBE.categoryKey === categoryKey && linkedBE.exerciseKey === exerciseKey
            )
        );
    });
};

export const getWeightInUserMeasurementSystem = (weightValue, unitKey) => {
    const weightInGrams = Personalizer.convertWeightToGramsByUnit(weightValue, unitKey);
    return Personalizer.personalizeWeight(weightInGrams);
};

export const getWeightWithUnit = (weightValue, unitKey) => {
    const weightInUserMeasurementSystem = getWeightInUserMeasurementSystem(weightValue, unitKey);
    const weightUnitTranslated = i18next.t(`units:${Personalizer.getWeightUnitKey()}`);
    return weightInUserMeasurementSystem + ' ' + weightUnitTranslated;
};

export const getUserWeightUnit = () => {
    return {
        unitKey: Personalizer.isMetricMeasurementSystem() ? MEASUREMENT_UNITS.kilogram : MEASUREMENT_UNITS.pound
    };
};
